export const header = {

}

export const actions = [
  {
    title: 'Reforestation massive cohérente et respectueuse',
    img: './img/impact/action_1.webp',
    alt: 'SeedOut fenua forêt dense',
    desc: 'Reforestation massive cohérente et respectueuse'
  },
  {
    title: 'Réimplantation du corail',
    img: './img/impact/action_2.webp',
    alt: 'SeedOut fenua photo de lagon et corail',
    desc: 'Réimplantation du corail'
  },
  {
    title: 'Réimplantation d’arbres de niches, endémiques et menacés',
    img: './img/impact/action_3.webp',
    alt: 'SeedOut fenua photo d\'arbre',
    desc: 'Réimplantation d’arbres de niches, endémiques et menacés'
  },
  {
    title: 'Culture d’arbres vivriers bio',
    img: './img/impact/action_4.webp',
    alt: 'SeedOut fenua culture d\'arbres vivriers et bio',
    desc: 'Culture d’arbres vivriers bio'
  }
]

export const preface = [
  {
    title: 'SeedOut Fenua finance de vrais projets de reforestation',
    img: './img/impact/impact_1.webp',
    alt: 'SeedOut Fenua photo de reforestation'
  },
  {
    title: 'SeedOut Fenua vos victoires pour la reforestation',
    img: './img/impact/impact_2.webp',
    alt: 'SeedOut Fenua photo de reforestation'
  }
]

export const advertising = {
  title: 'Photo téléphone mobile et forêt',
  video: './img/impact/video.mp4',
  alt: 'SeedOut Fenua régie publicitaire'
}

export const partners = [
  {
    title: 'UN ENFANT, UN ARBRE, UN CORAIL. \'E.A.C\'',
    desc: 'Depuis toujours, nos aînés ont fait perdurer le \'pūfenua\'. Cette tradition qui consiste à enterrer le placenta de chaque nouveau né sous un arbre fruitier, afin de marquer le lien entre la terre, l\'île et l\'enfant',
    img: './img/impact/assoc_cover_1x.webp',
    alt: './img/impact/association_eac.jpg',
    link: 'https://www.facebook.com/groups/2226861147582295',
    sliderImages: [
      './img/impact/associations/eac/eac_cover_1.jpg',
      './img/impact/associations/eac/eac_cover_2.jpg',
      './img/impact/associations/eac/eac_cover_3.jpg'
    ]
  },
  {
    title: 'TAMARI"I / POINTE DES PÊCHEURS',
    desc: 'Cette association à but non lucratif, est reconnue d’intérêt général et a pour objet de promouvoir et d’assurer la protection du lagon et de son environnement à la Pointe des Pêcheurs sur l’île de Tahiti, en Polynésie Française',
    img: './img/impact/assoc_cover_2x.webp',
    alt: './img/impact/association_pdp.jpg',
    link: 'https://www.facebook.com/TamariiPointeDesPecheurs',
    sliderImages: [
      './img/impact/associations/pdp/pdp_cover_1.jpg',
      './img/impact/associations/pdp/pdp_cover_2.jpg',
      './img/impact/associations/pdp/pdp_cover_3.jpg'
    ]
  },
  {
    title: 'MANU SOP',
    desc: 'La Société d’Ornithologie de Polynésie "MANU", fondée en juillet 1990 par quelques amateurs passionnés par les oiseaux de Polynésie française, a pour but d’œuvrer pour la protection des oiseaux, de leurs habitats et de la biodiversité en travaillant avec la population dans le cadre d’une gestion durable des ressources naturelles',
    img: './img/impact/assoc_cover_3x.webp',
    alt: './img/impact/association_manu.jpg',
    link: 'https://www.facebook.com/Manu-SOP-212922695414646',
    sliderImages: [
      './img/impact/associations/manu/manu_cover_1.jpg',
      './img/impact/associations/manu/manu_cover_2.jpg',
      './img/impact/associations/manu/manu_cover_3.jpg'
    ]
  },
];
